import { Sort } from './sort';

export class PageResponse<T> {
  content: Array<T>;
  number: number; // page number
  size: number; // page size
  numberOfElements: number;
  totalPages: number;
  sort: Array<Sort>;
}
